import type { RouteObject } from 'react-router-dom';

import MainLayout from '@/app/layouts/MainLayout';
import { AuthGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { EducationCartProvider } from '@/features/education';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * 교육(/education) 라우트.
 *
 * 목록·과정 상세는 공개(비로그인 열람) — 접수만 AuthGuard 아래다. 결제·환불·명부
 * 신원이 계정에 달려 있어 게스트 접수를 열 수 없다.
 *
 * 장바구니 Provider 를 이 서브트리에 두는 이유: 담은 회차는 교육 화면 밖에서
 * 의미가 없다. 앱 루트에 올리면 모든 페이지가 교육 상태를 지고 다닌다.
 */
export const educationRoutes: RouteObject = {
  path: ROUTES.EDUCATION,
  element: (
    <EducationCartProvider>
      <MainLayout />
    </EducationCartProvider>
  ),
  children: [
    {
      index: true,
      ...lazyRoute(() => import('@/pages/education/EducationPage')),
    },
    {
      path: ROUTES.EDUCATION_COURSE,
      ...lazyRoute(() => import('@/pages/education/EducationCoursePage')),
    },
    {
      element: <AuthGuard />,
      children: [
        {
          path: ROUTES.EDUCATION_CHECKOUT,
          ...lazyRoute(() => import('@/pages/education/EducationCheckoutPage')),
        },
        {
          path: ROUTES.EDUCATION_REGISTRATIONS,
          ...lazyRoute(() => import('@/pages/education/MyEducationPage')),
        },
        {
          path: ROUTES.EDUCATION_REGISTRATION_DETAIL,
          ...lazyRoute(() => import('@/pages/education/MyEducationDetailPage')),
        },
      ],
    },
  ],
};
